<div *ngIf="clientType && clientType === 'Person'">
  Type of ID is Person. you cann't modify Organisation data.
</div>
<form *ngIf="!fieldDefinition.isHidden && (!clientType || clientType === 'Organisation')"
      (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <div class="w-n-600 flex flex-col">
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-0-0-100">
        <mat-label>Organisation Name</mat-label>
        <mat-select (selectionChange)="onSelectRTP($event)" formControlName="OrganisationName_6_p" required>
          <mat-option *ngFor="let releventTaxpayer of releventTaxpayers" [value]="releventTaxpayer.entityName">
            {{releventTaxpayer.entityName}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="inputFormError.OrganisationName_6_p.required">
          Organisation Name is required!
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Organisation Code</mat-label>
        <input formControlName="EntityCode" matInput placeholder=""
               particleAnalytics
               analyticsAction="EntityCode-input"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-0-0-100">
        <mat-label>Country of Residence</mat-label>
        <mat-select formControlName="ResidenceCountryCode_12_p" required>
          <mat-option *ngFor="let country of countryList" [value]="country.code">
            {{country.name}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="inputFormError.ResidenceCountryCode_12_p.required">
          Country of Residence is required!
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Tin</mat-label>
        <input formControlName="Tin_12_p" matInput placeholder=""
               particleAnalytics
               analyticsAction="Tin_12_p-input"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Email</mat-label>
        <input formControlName="EmailAddress_6_p" matInput placeholder=""
               particleAnalytics
               analyticsAction="EmailAddress_6_p-input"
        />
      </mat-form-field>
    </div>
  </div>

</form>

